module.exports = __webpack_public_path__ + "static/media/19723595.92d8f25b.png";